/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionsModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly title: string | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModuleItem_item">;
    } | null> | null;
    readonly " $refType": "HpRespCollectionsModule_componentModule";
};
export type HpRespCollectionsModule_componentModule$data = HpRespCollectionsModule_componentModule;
export type HpRespCollectionsModule_componentModule$key = {
    readonly " $data"?: HpRespCollectionsModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespCollectionsModule_componentModule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespCollectionsModuleItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CollectionsModule",
  "abstractKey": null
};
})();
(node as any).hash = 'b0b1c9adc3d5b7705a90de1f41b126e6';
export default node;
